<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>
              <v-icon color="#077893" @click="Fn_BackIndex" size="38"
                >mdi-chevron-left</v-icon
              >
              {{ $t("mcg.cgd") }}
            </h2>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-start pt-3 pb-5>
          <v-flex xs11 lg11 pa-5>
            <v-card class="rounded-lg">
              <v-card-title primary-title>
                {{ $t("mcg.gdi") }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap justify-center align-center pa-6>
                  <v-flex xs11 lg11>
                    <b>{{ $t("mcg.row2") }} : </b><br />{{ GroupName }} <br />
                    <!-- <v-text-field
                      outlined
                      dense
                      disabled
                      color="info"
                      v-model="GroupName"
                    ></v-text-field> -->
                  </v-flex>
                  <v-flex xs11 lg11 mt-3>
                    <b>{{ $t("dashboard.policy") }} : </b><br />{{
                      SelectPolicy.PolicyTitle
                    }}
                  </v-flex>
                  <!-- Policy -->
                  <!-- <v-flex xs11 lg11>
                    <v-autocomplete
                      return-object
                      item-text="Title"
                      item-value="PolicyId"
                      :items="ItemPolicy"
                      v-model="SelectPolicy"
                      deletable-chips
                      color="info"
                      outlined
                      dense
                      chips
                      disabled
                      small-chips
                    >
                    </v-autocomplete>
                  </v-flex> -->
                  <v-flex xs11 md11 lg11 mt-3>
                    <b>{{ $t("consentform.exdate") }} : </b><br />{{
                      ExpirationDate
                    }}
                    {{ $t("upload.text7") }}
                    <!-- <v-text-field
                      color="#077893"
                      :label="$t('consentlist.expiration')"
                      v-model="ExpirationDate"
                      outlined
                      dense
                      disabled
                      clearable
                    >
                    </v-text-field> -->
                  </v-flex>
                  <v-flex xs11 md11 lg11 mt-3>
                    <b v-if="$t('default') === 'th'">ข้อมูลที่ต้องการขอ :</b>
                    <b v-else>Personal Data to Request :</b>
                    <v-row>
                      <v-col cols="12" md="12">
                        <v-chip
                          small
                          style="border: 1px solid"
                          v-for="(item, i) in itemsRequest"
                          :key="i"
                          class="ma-1"
                          label
                          text-color="#077893"
                          color="#ddf7ff"
                        >
                          <b>{{ item }}</b>
                        </v-chip>
                      </v-col>
                    </v-row>
                    <!-- <v-combobox
                      color="#077893"
                      v-model="itemsRequest"
                      :items="itemsRequest"
                      required
                      persistent-hint
                      append-icon=""
                      hide-selected
                      multiple
                      outlined
                      dense
                      clearable
                      small-chips
                      deletable-chips
                      disabled
                    >
                    </v-combobox> -->
                  </v-flex>
                  <v-flex xs11 lg11 mt-3>
                    <b>{{ $t("consentform.brief") }} : </b>
                  </v-flex>
                  <v-flex xs11 lg11 mt-3>
                    <!-- <v-textarea
                      color="#077893"
                      outlined
                      no-resize
                      v-model="Title"
                      disabled
                    ></v-textarea> -->
                    <v-card color="#ddf7ff" class="elevation-0">
                      <v-card-text>
                        <v-layout row wrap align-center>
                          <p class="text-justify" style="text-indent: 1rem">
                            {{ Title }}
                          </p>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                  <!-- example Consent-->
                  <v-flex xs11 lg11 pt-4>
                    <v-card outlined>
                      <v-card-text>
                        <b style="text-decoration: underline">{{
                          $t("Toolbar.consent")
                        }}</b>
                        <div
                          v-for="(item, index) in ItemsDataSelect"
                          :key="index"
                          style="display: inline"
                        >
                          <span class="black--text pl-3 FontSize">
                            {{ item.HeaderConsent }}
                          </span>
                        </div>
                        <draggable
                          :list="ItemsDataSelect"
                          :disabled="!Enabled"
                          class="list-group move"
                          ghost-class="ghost"
                          :move="Fn_CheckMove"
                          @start="Dragging = true"
                          @end="Dragging = false"
                        >
                          <div
                            class="list-group-item"
                            v-for="(item, index) in ItemsDataSelect"
                            :key="index + 1"
                          >
                            <v-card color="#ddf7ff" class="elevation-0 ma-3">
                              <v-card-text>
                                <v-layout row wrap align-center>
                                  <v-flex xs10 lg10 text-left>
                                    <b> {{ item.HeaderConsent }}</b>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                            </v-card>
                          </div>
                        </draggable>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import draggable from "vuedraggable";
import { mapGetters } from "vuex";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { draggable },
  data: function () {
    return {
      Enabled: false,
      Dragging: false,
      LoadingPolicy: false,
      ItemsData: [],
      ItemsDataSelect: [],
      ItemPolicy: [],
      ItemConsent: [],
      GroupName: "",
      Content: "",
      SelectPolicy: "",
      SelectConsent: "",
      DataConsent: [],
      PolicyId: "",
      BusinessName: "",
      ExpirationDate: "",
      Title: "",
      addRequest: [],
      itemsRequest: [],
    };
  },
  computed: {
    ...mapGetters(["Business"]),
    ...mapGetters(["DataConsentGroup"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },
    draggingInfo() {
      return this.Dragging ? "under drag" : "";
    },
    _GroupId: {
      get() {
        return this.DataConsentGroup.GroupId || "-";
      },
    },
  },
  mounted() {
    this.Fn_GetDataPolicy();
    this.Fn_GetDataConsent();
    this.Fn_GetDataConsentGroup();
  },
  methods: {
    Fn_CheckMove: function (e) {

    },
    async Fn_GetDataPolicy() {
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "policy/GetAllDetailPolicy",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          if (response.data.Status === "OK") {
            this.ItemPolicy = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    async Fn_GetDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.ItemConsent = response.data.Message;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    async Fn_GetDataConsentGroup() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        GroupId: this._GroupId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "group-consent/GetDetailGroupConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.Data = response.data.Message;

            this.BusinessName = response.data.Message.BusinessNameTh;
            this.GroupName = response.data.Message.GroupName;
            this.GroupId = response.data.Message.GroupId;
            this.PolicyId = response.data.Message.Policy.PolicyId;
            this.SelectPolicy = response.data.Message.Policy;
            this.SelectConsent = response.data.Message.Consent;
            this.ItemsDataSelect = response.data.Message.Consent;
            this.ItemsData = response.data.Message.Consent;
            this.ExpirationDate = response.data.Message.ExpireIn;
            this.Title = response.data.Message.Title;
            var FixArray = response.data.Message.Tag;
            if (FixArray == "") {
            } else {
              FixArray = FixArray.split(",").map((item) => item.trim());
              this.itemsRequest = FixArray;

            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title:
                this.$i18n.t("alert.contactserve") +
                error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: this.$i18n.t("alert.contactserve") + error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title:
                this.$t("report_instead.swal.catch_err") + error.message ||
                error,
            });
          }
        });
    },
    Fn_BackIndex() {
      this.$router.push("/consent-management-group-index");
    },
  },
  watch: {
    SelectConsent(val) {
      this.ItemsDataSelect = [];
      this.ItemsData = [];
      if (val) {
        var index = 0;
        for (var i in this.SelectConsent) {
          index += 1;
          this.GroupSelect = {
            GroupConsentId: this.SelectConsent[i].ConsentId,
            Level: index,
          };
          this.GroupDefault = {
            HeaderConsent: this.SelectConsent[i].HeaderConsent,
          };
          this.ItemsData.push(this.GroupSelect);
          this.ItemsDataSelect.push(this.GroupDefault);
        }
      }
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.move {
  cursor: move;
}

.FontSize {
  font-size: 14px;
}
</style>
